export class RefetchManager {
  constructor({ refetchCount = 0, refetchInterval = 3000 } = {}) {
    this.defaultRefetchInterval = refetchInterval
    this.refetchCount = refetchCount
    this.refetchInterval = refetchInterval
    this.intervalId = null
  }

  startRefetch(refetch) {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }

    const refetchWithDynamicInterval = () => {
      if (this.refetchCount < 2) {
        this.refetchCount += 1
      } else {
        this.refetchInterval *= 3
      }
      refetch()
      this.setNewInterval(refetchWithDynamicInterval)
    }

    this.setNewInterval(refetchWithDynamicInterval)
  }

  setNewInterval(callback) {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
    this.intervalId = setInterval(callback, this.refetchInterval)
  }

  resetRefetch(refetch) {
    this.refetchCount = 0
    this.refetchInterval = this.defaultRefetchInterval
    this.startRefetch(refetch)
  }

  clearRefetch() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
      this.refetchCount = 0
      this.refetchInterval = this.defaultRefetchInterval
    }
  }
}

const refetchManager = new RefetchManager()
export default refetchManager
